import { ILoggingService, TicketMaxStakeVisibility, ICouponSentData } from 'eTip--common';
import { getAvailableLanguages, ILanguage } from 'easit--localization';
import { ILiveAppSettings } from '../../liveAppEnvironment';
import { IAspxApiForMts } from '../apiAspxNotification';
import * as routing from 'easit--routing';

export interface ILiveAspxApi extends IAspxApiForMts {
    getSettings: () => ILiveAppSettings;
}

export function connectRealAspxApi(): ILiveAspxApi {  //TODOHL very similar to IAspxApi
    var reactLive: IReactLive = (<any>window).reactLive; //TODO any => WindowWithReactLive
    return {
        init: (_aLoggingService: ILoggingService) => {
            routing.subscribeForPageChanged(() => { reactLive.god.pageChanged(); });
            reactLive.god.subscribeForChangeReactPage((relUrl: string) => {
                routing.push(relUrl);
            });
        },
        settingsLoaded: (loadDataResponse: any) => {
            reactLive.god.reactSettingsLoaded(loadDataResponse);
        },
        sessionTokenExpired: () => {
            reactLive.god.tokenExpired();
        },
        sessionTokenOk: () => {
            reactLive.god.tokenOk();
        },
        getSettings: (): ILiveAppSettings => {
            var settings = reactLive.god.getLaunchSettings();
            var language = getAvailableLanguages().get(settings.languageId);

            if (language == null) {
                throw new Error('Language ' + settings.languageId + ' not found');
            }

            return {
                language: language,
                isDebug: settings.isDebug,
                apiBaseUrl: settings.apiBaseUrl,
                tokenVersion: settings.version,
                userSecureId: settings.sid,
                serverOffsetMin: settings.serverOffsetMin,
                categoriesTreeRefreshTime: settings.categoriesTreeRefreshTimeMs,
                eventDetailRefreshTime: settings.eventDetailRefreshTimeMs,
                topBetsRefreshTime: settings.topBetsRefreshTimeMs,
                serverGuid: settings.serverGuid,
                loginUrl: settings.loginUrl,
                drawTipName: settings.drawTipName,
                currency: settings.currency,
                pointsCurrency: settings.pointCurrency,
                matchTrackerUA: settings.matchTrackerUA,
                liveStreamUA: settings.liveStreamUA,
                soundFilesBaseUrl: settings.soundFilesBaseUrl,
                liveEventListRefreshTimeMs: settings.liveEventListRefreshTimeMs,
                ticketDetailLiveScoreRefreshTimeMs: settings.ticketDetailLiveScoreRefreshTimeMs,
                connectionTimeoutMs: settings.connectionTimeoutMs,
                template: settings.template,
                legacySBUrl: settings.legacySBUrl,
                //version: settings.version,
                isChatFeatureAvailable: settings.isChatFeatureAvailable,
                stakeButtons: settings.stakeButtons,
                canShowAliasNumberInTicket: settings.canShowAliasNumberInTicket,
                canDisableSignalRSSE: settings.canDisableSignalRSSE,
                canShowMobileAppAdvert: settings.canShowMobileAppAdvert,
                canShowNewFeatureScore: settings.canShowNewFeatureScore,
                canShowExtendedTicketDetail: settings.canShowExtendedTicketDetail,
                canShowProductsInTicket: settings.canShowProductsInTicket,
                canShowOneTapBet: settings.canShowOneTapBet,
                matchTrackerKey: settings.matchTrackerKey,
                initLoader: settings.initLoader,
                canShowVirtualGamesTickets: settings.canShowVirtualGamesTickets,
                apiVirtualGamesBaseUrl: settings.apiVirtualGamesBaseUrl,
                canLiveEventsListCollapseSport: settings.canLiveEventsListCollapseSport,
                ticketMaxStakeVisibility: settings.ticketMaxStakeVisibility,
                mobileCodeAdvert: settings.mobileCodeAdvert,
                canShortcutMobileLiveDisciplineNames: false,
                freeTicketBonusUrl: settings.freeTicketBonusUrl,
                canShowLiveEventDetailGroupTabs: settings.canShowLiveEventDetailGroupTabs,
                canShowTopXBets: settings.canShowTopXBets,
                topXBetsButtonsSetting: settings.topXBetsButtonsSetting,
                recaptchaSiteKey: settings.recaptchaSiteKey,
                canShowLiveInPrematch: false,
                canShowLiveEventStatusInTicketDetail: settings.canShowLiveEventStatusInTicketDetail,
                canFilterVideoAndMTWithSport: settings.canFilterVideoAndMTWithSport
            };
        },
        footerWidthChange: () => {
            reactLive.tools.checkResponsiveFooter();
        },
        couponSent: (data: ICouponSentData) => {
            reactLive.god.couponSent(data);
        }
    };
}

export function connectDevelAspxApi(defaultLanguage: ILanguage, tokenVersion: string, timeZoneOffsetMin: number): ILiveAspxApi {
    let loggingService: ILoggingService;

    return {
        init: (aLoggingService: ILoggingService) => {
            loggingService = aLoggingService;
        },
        settingsLoaded: (_loadDataResponse: any) => {
            //loggingService.info('settingsLoaded, token ' + loadDataResponse.data.Token);
        },
        sessionTokenExpired: () => {
            loggingService.info('Session expired');
        },
        sessionTokenOk: () => { },
        getSettings: (): ILiveAppSettings => {
            return {
                language: defaultLanguage,
                isDebug: true,
                apiBaseUrl: __API__,
                tokenVersion: tokenVersion,
                userSecureId: null,
                serverOffsetMin: timeZoneOffsetMin,
                categoriesTreeRefreshTime: 60 * 1000,
                eventDetailRefreshTime: 60 * 1000,
                topBetsRefreshTime: 60 * 1000,
                serverGuid: '=serverguid=',
                loginUrl: "loginUrl",
                drawTipName: __IsMTS__ ? '0' : "X",
                currency: '€',
                pointsCurrency: "p.",
                matchTrackerUA: 0,
                liveStreamUA: -2,
                liveEventListRefreshTimeMs: 10000,
                ticketDetailLiveScoreRefreshTimeMs: 10000,
                connectionTimeoutMs: 30000,
                soundFilesBaseUrl: "http://sport.synottip.ebet.localhost/content/v3/sounds",
                template: { primaryColor: __DevelPrimaryColor__, switchColor: __DevelSwitchColor__, loaderColor: __DevelLoaderColor__, loaderFlashColor: __DevelLoaderFlashColor__, otbActiveSwitchColor: __DevelOTBActiveSwitchColor__ },
                legacySBUrl: "",
                //version: 'CZ-I',
                isChatFeatureAvailable: true,
                stakeButtons: __IsMTSTipos__ ? [10, 20, 50, 100, "MAX"] : [10, 20, 50, 100, 200],
                canShowAliasNumberInTicket: true,
                canShowMobileAppAdvert: true,
                canShowNewFeatureScore: true,
                canShowExtendedTicketDetail: true,
                canShowProductsInTicket: true,
                canShowOneTapBet: true,
                matchTrackerKey: __IsMTS__ && !__IsMTSTipos__ ? "8663d777139c4142a793180b76596695" : "9bc6162232c6113bebd0459927726c5d",
                canShowVirtualGamesTickets: true,
                apiVirtualGamesBaseUrl: __API_VIRTUAL_GAMES__,
                canLiveEventsListCollapseSport: true,
                ticketMaxStakeVisibility: TicketMaxStakeVisibility.InStakeLabel,
                mobileCodeAdvert: {
                    androidLinkUrl: "https://play.google.com/store/apps/details?id=sk.tiposplay.production",
                    appleLinkUrl: "https://apps.apple.com/sk/app/tipos/id6446995582?l=sk"
                },
                canShortcutMobileLiveDisciplineNames: false,
                freeTicketBonusUrl: '',
                canShowLiveEventDetailGroupTabs: false,
                canShowTopXBets: false,
                topXBetsButtonsSetting: null,
                recaptchaSiteKey: null,
                canShowLiveInPrematch: false,
                canShowLiveEventStatusInTicketDetail: true,
                canFilterVideoAndMTWithSport: __IsMTSTipos__
            };
        },
        footerWidthChange: () => {
            //loggingService.info('footer width change');
        },
        couponSent: () => { }
    };
}
